<template>
  <div class="relative flex flex-col">
    <div class="main_loader__cover" :class="{ main_loader__loading: isLoading }">
      <img class="money-logo__animated" alt="Moroku Money logo" :src="currentThemeAssets?.logoSecondary" />
    </div>

    <div v-if="!isLoading || !canHidePage" v-show="!isLoading">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useTheme } from "@moroku/money-webapp-components";
import { computed } from "vue";
import { useMoneyRouter } from "@/router";
import useAuthUser from "@/composables/useAuthUser";
import { useQuery } from "@vue/apollo-composable";
import { customerQuery } from "@/api/userApi";
import { useFragment } from "@/api/generated";
import { CustomerFragmentFragmentDoc } from "@/api/generated/graphql";
import { useRoute } from "vue-router";
import { routeNames } from "@/router/constants";
import { featureEnabled } from "@/config";
import { MoneyFeatures } from "@/config/constants";
import type { WatchQueryFetchPolicy } from "@apollo/client/core/watchQueryOptions";

const route = useRoute();
const { currentThemeAssets } = useTheme();
const { isLoadingAuthAndCustomer } = useMoneyRouter();
const { authUser, loadingAuthUser } = useAuthUser();

const customerFetchOptions = computed(() => ({
  fetchPolicy: (authUser.value ? "cache-first" : "cache-only") as WatchQueryFetchPolicy,
}));
const { result: customerResult } = useQuery(customerQuery, {}, customerFetchOptions);

const customerExists = computed(() => !!useFragment(CustomerFragmentFragmentDoc, customerResult.value?.customer));

const isLoading = computed(() => (isLoadingAuthAndCustomer.value || loadingAuthUser.value) && !customerExists.value);

const canHidePage = computed(() => !featureEnabled(MoneyFeatures.Lending) && [routeNames.LOAN_APPLICATION].includes(route.name as any));
</script>

<style lang="scss" scoped>
.main_loader__cover {
  @apply pointer-events-none absolute inset-0 z-50 flex h-screen items-center justify-center bg-white opacity-0 transition-opacity duration-500;

  &.main_loader__loading {
    @apply pointer-events-auto opacity-100;
  }
}

.money-logo__animated {
  @apply h-32 max-w-full animate-pulse object-contain p-8;
}
</style>
